import { ROOT_URL, saveError } from "Api";
import service from "Api/service";
import {
  openLoadingSpinner,
  closeLoadingSpinner
} from "./LoadingSpinnerActions";
import {
  FETCH_CONNECT_DEFAULT_REQUEST,
  FETCH_CONNECT_DEFAULT_FAILURE,
  FETCH_CONNECT_DEFAULT_SUCCESS,
  UPDATE_CONNECT_DEFAULT_REQUEST,
  UPDATE_CONNECT_DEFAULT_FAILURE,
  UPDATE_CONNECT_DEFAULT_SUCCESS,
  DEBOUNCED_UPDATE_CONNECT_DEFAULT_REQUEST
} from "Constants/redux";

export const fetchConnectDefault = () => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_CONNECT_DEFAULT_REQUEST });
    service
      .get(`${ROOT_URL}/connect_default/`)
      .then(response => {
        return dispatch({
          response: response.data,
          type: FETCH_CONNECT_DEFAULT_SUCCESS
        });
      })
      .catch(error => {
        console.log(error);
        saveError(error, getState());
        dispatch({
          error,
          type: FETCH_CONNECT_DEFAULT_FAILURE
        });
      });
  };
};

export const updateConnectDefault = data => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_CONNECT_DEFAULT_REQUEST,
      data: data
    });
    dispatch(openLoadingSpinner("Updating..."));
    return service
      .patch(`${ROOT_URL}/connect_default/`, data)
      .then(response => {
        dispatch(closeLoadingSpinner());
        return dispatch({
          response: response.data,
          type: UPDATE_CONNECT_DEFAULT_SUCCESS
        });
      })
      .catch(error => {
        console.log(error);
        dispatch(closeLoadingSpinner());
        return dispatch({
          error,
          type: UPDATE_CONNECT_DEFAULT_FAILURE
        });
      });
  };
};

export const removeLocationFromConnectDefault = locationConnectDefaultRelationship => {
  return (dispatch, getState) => {
    return service
      .patch(`${ROOT_URL}/connect_default/remove_location`, {
        id: locationConnectDefaultRelationship.id
      })
      .then(response => {
        return dispatch({
          response: response.data,
          type: UPDATE_CONNECT_DEFAULT_SUCCESS
        });
      })
      .catch(error => {
        console.log(error);
        return dispatch({
          error,
          type: UPDATE_CONNECT_DEFAULT_FAILURE
        });
      });
  };
};

export const debouncedUpdateConnectDefault = data => {
  return (dispatch, getState) => {
    dispatch({
      type: DEBOUNCED_UPDATE_CONNECT_DEFAULT_REQUEST,
      data: data
    });
  };
};
